import React from 'react';
import {View} from 'react-native';
import {tID} from '../../../utils/TestIdHelper';
import Input from '../../elements/Input';
import makeStyles from './styles.web';
import {useThemedStyles} from '../../../theme';

const UI = ({
  employerName,
  onChangeEmployer,
  firstName,
  onChangeFirstName,
  lastName,
  onChangeLastName,
  email,
  onChangeEmail,
  hasError,
  errorText,
  firstHasError,
  lastHasError,
}) => {
  const styles = useThemedStyles(makeStyles);
  return (
    <View testID={tID('RequestIdForm-View-Container')}>
      <View style={styles.inputContainer}>
        <Input
          testID={tID('RequestIdForm-Input-Employer')}
          placeholder={'Type here...'}
          inputTitle={'Your Employer'}
          value={employerName}
          onChangeText={onChangeEmployer}
          containerStyle={styles.leftInput}
        />
        <Input
          testID={tID('RequestIdForm-Input-FirstName')}
          hasError={firstHasError}
          errorText="Name can only contain letters."
          placeholder={'Type here...'}
          inputTitle={'First Name'}
          value={firstName}
          onChangeText={onChangeFirstName}
          containerStyle={styles.rightInput}
        />
      </View>
      <View style={styles.inputContainer}>
        <Input
          testID={tID('RequestIdForm-Input-LastName')}
          hasError={lastHasError}
          errorText="Name can only contain letters."
          placeholder={'Type here...'}
          inputTitle={'Last Name'}
          value={lastName}
          onChangeText={onChangeLastName}
          containerStyle={styles.leftInput}
        />
        <Input
          testID={tID('RequestIdForm-Input-Email')}
          hasError={hasError}
          errorText={errorText}
          placeholder={'Type here...'}
          inputTitle={'Email'}
          value={email}
          onChangeText={onChangeEmail}
          keyboardType={'email-address'}
          containerStyle={styles.rightInput}
        />
      </View>
    </View>
  );
};

export default UI;
